// extracted by mini-css-extract-plugin
export var errorsContainer = "_tw-1";
export var link = "_tw-0";